import fetch from 'isomorphic-fetch';
import ENV from '../environments/environment'

const couponService = {

   async redeemCoupon(coupon) {
     coupon = JSON.stringify(coupon);
     const response = await fetch(`${ENV.lupita_url}coupons/redeem/` , { headers: ENV.getLupitaHeaders() ,  method: "POST", body: coupon });
     return await response.json();
   }



}

export default couponService;



// WEBPACK FOOTER //
// ./src/services/coupon.service.js